import angular from 'angular';
import SelfRegistrationComponent from './self-registration/self-registration-component';
import SelfRegistrationRetailerComponent from './retailer/retailer-component';
import SelfRegistrationRetailerIndependentComponent from './independent/independent-component';
import SelfRegistrationRetailerChainHeadComponent from './chain-head/chain-head-component';
import SelfRegistrationRetailerChainSubordinateComponent from './chain-subordinate/chain-subordinate-component';
import SelfRegistrationConfirmComponent from './confirm-registration/confirm-registration-component';
import SelfRegistrationConfirmationComponent from './confirmation-registration/confirmation-registration-component';
import SelfRegistrationDisabledComponent from './registration-disabled/registration-disabled-component';

export default angular
  .module('self-registration', [])
  .component('selfRegistration', new SelfRegistrationComponent())
  .component('selfRegistrationRetailer', new SelfRegistrationRetailerComponent())
  .component('selfRegistrationRetailerIndependent', new SelfRegistrationRetailerIndependentComponent())
  .component('selfRegistrationRetailerChainHead', new SelfRegistrationRetailerChainHeadComponent())
  .component('selfRegistrationRetailerChainSubordinate', new SelfRegistrationRetailerChainSubordinateComponent())
  .component('selfRegistrationConfirm', new SelfRegistrationConfirmComponent())
  .component('selfRegistrationConfirmation', new SelfRegistrationConfirmationComponent())
  .component('selfRegistrationDisabled', new SelfRegistrationDisabledComponent());



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/self-registration-module.js